import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import axios from "axios";

Vue.use(VueRouter);

// Layout
import UnAuthLayout from "../views/layouts/unauth-layout.vue";
import AuthLayout from "../views/layouts/auth-layout.vue";

// Static
import HomePage from "../views/home";

// Auth
import LoginPage from "../views/auth/login.vue";
import ForgotPasswordPage from "../views/auth/forgot-password.vue";

// Companies
import CompaniesPage from "../views/companies/index.vue";
import CompanyCreatePage from "../views/companies/create.vue";
import CompanyIdPage from "../views/companies/id.vue";

// Users
import UsersPage from "../views/users/index.vue";
import UserCreatePage from "../views/users/create.vue";
import UserIdPage from "../views/users/id.vue";
import ProfilePage from "../views/users/id.vue";
import UsersUploadPage from "../views/users/upload.vue";
import UsersKYCDetailsPage from "../views/kyc-details/index.vue";

// Positions
import PositionsPage from "../views/positions/index.vue";
import PositionCreatePage from "../views/positions/create.vue";
import PositionIdPage from "../views/positions/id.vue";

// Roles
import RolesPage from "../views/roles/index.vue";
import RoleIdPage from "../views/roles/id.vue";

// Modules
import ModulesPage from "../views/modules/index.vue";
import ModuleCreatePage from "../views/modules/create.vue";
import ModuleIdPage from "../views/modules/id.vue";

// Outlets
import OutletsPage from "../views/outlets/index.vue";
import OutletCreatePage from "../views/outlets/create.vue";
import OutletIdPage from "../views/outlets/id.vue";
import OutletsUploadPage from "../views/outlets/upload.vue";

// Outlet Users
import OutletUsersPage from "../views/outlets/outlet-users/index.vue";
import OutletUserCreatePage from "../views/outlets/outlet-users/create.vue";
import OutletUserIdPage from "../views/outlets/outlet-users/id.vue";

// Pjps
import PjpsPage from "../views/pjps/index.vue";
import PjpCreatePage from "../views/pjps/create.vue";
import PjpIdPage from "../views/pjps/id.vue";
import PjpsUploadPage from "../views/pjps/upload.vue";
import PjpCopyReferencesPage from "../views/pjps/copy-pjp-references.vue";
import PjpCopyPreviousMonth from "../views/pjps/copy-pjp-prev-month.vue";

// PjpReferences
import PjpReferencesPage from "../views/pjp-references/index.vue";
import PjpReferenceCreatePage from "../views/pjp-references/create.vue";
import PjpReferenceIdPage from "../views/pjp-references/id.vue";

// Permissions
import PermissionsPage from "../views/permissions/index.vue";
import PermissionCreatePage from "../views/permissions/create.vue";
import PermissionIdPage from "../views/permissions/id.vue";

// Values
import Values from "@/views/values/index.vue";
import ValueCreate from "@/views/values/create.vue";
import ValueId from "@/views/values/id.vue";

// ValueLists
import ValueLists from "@/views/value-lists/index.vue";
import ValueListUpload from "@/views/value-lists/upload.vue";
import ValueListCreate from "@/views/value-lists/create.vue";
import ValueListId from "@/views/value-lists/id.vue";

// User Timestamps
import UserTimestamps from "@/views/user-timestamps/index.vue";

// Banners
import BannersPage from "../views/banners/index.vue";
import BannerCreatePage from "../views/banners/create.vue";
import BannerIdPage from "../views/banners/id.vue";
// Products
import ProductsPage from "../views/products/index.vue";
import ProductCreatePage from "../views/products/create.vue";
import ProductIdPage from "../views/products/id.vue";
import ProductIDetailsPage from "../views/products/indexlists.vue";

// Categorys
import CategoriesPage from "../views/categories/index.vue";
import CategoryCreatePage from "../views/categories/create.vue";
import CategoryIdPage from "../views/categories/id.vue";
//sub-categories
import SubcategoryPage from "../views/sub-categories/index.vue";
import SubcategoryCreatePage from "../views/sub-categories/create.vue";
import SubcategoryIdPage from "../views/sub-categories/id.vue";
// //wishlists
import WishlistsPage from "../views/wishlists/index.vue";
// //Bank Details
import BankDetailsPage from "../views/bank-details/index.vue";
//Carts
import CartsPage from "../views/carts/index.vue";
import CartCreatePage from "../views/carts/create.vue";
//coupons
import CouponsPage from "../views/coupons/index.vue";
import CouponCreatePage from "../views/coupons/create.vue";
import CouponIdPage from "../views/coupons/id.vue";
//account
import DeleteAccountRequestPage from "../views/delete-requests/create.vue";
import DeleteAccountRequestIndexPage from "../views/delete-requests/index.vue";
//legal
import TermsAndConditionsPage from "../views/legal/terms-and-conditions.vue";
import PrivacyPolicyPage from "../views/legal/privacy-policy.vue";
//UserAddress
import UserAddressesPage from "../views/addresses/index.vue";
//notifications
import NotificationsPage from "../views/notifications/index.vue";
import NotificationCreatePage from "../views/notifications/create.vue";
import NotificationIdPage from "../views/notifications/id.vue";
//stores
import StoresPage from "../views/stores/index.vue";
import StoreCreatePage from "../views/stores/create.vue";
import StoreIdPage from "../views/stores/id.vue";
//Kyc Details
import UsersKYCDetailCreatePage from "../views/kyc-details/create.vue";
import UsersKYCDetailIdPage from "../views/kyc-details/id.vue";
//Ticket
import ChatsPage from "../views/chats/index.vue";
import TicketsPage from "../views/tickets/index.vue";
import TicketIdPage from "../views/tickets/id.vue";
// Withdrawals
import WithdrawalsPage from "../views/withdrawals/index.vue";
// //orders
import OrdersPage from "../views/orders/index.vue";
import OrderCreatePage from "../views/orders/create.vue";
import OrderIdPage from "../views/orders/id.vue";
import OrderDetailsPage from "../views/order-details/index.vue";
// //offers
import OffersPage from "../views/offers/index.vue";
import OfferCreatePage from "../views/offers/create.vue";
import OfferIdPage from "../views/offers/id.vue";
//User Subscription
import UserSubscriptionsPage from "../views/user-subscriptions/index.vue";

const routes = [
  // AuthLayout
  {
    path: "/auth",
    name: "AuthLayout",
    component: AuthLayout,
    children: [
      {
        path: "/home",
        name: "HomePage",
        component: HomePage,
      },
      // Comapnies
      {
        path: "/companies",
        name: "CompaniesPage",
        component: CompaniesPage,
      },
      {
        path: "/companies/create",
        name: "CompanyCreatePage",
        component: CompanyCreatePage,
      },
      {
        path: "/companies/:companyId",
        name: "CompanyIdPage",
        component: CompanyIdPage,
      },
      // Users
      {
        path: "/users",
        name: "UsersPage",
        component: UsersPage,
      },
      {
        path: "/users/create",
        name: "UserCreatePage",
        component: UserCreatePage,
      },
      {
        path: "/users/upload",
        name: "UsersUploadPage",
        component: UsersUploadPage,
      },
      //KYC Details
      {
        path: "/user-kyc-details/create",
        name: "UsersKYCDetailCreatePage",
        component: UsersKYCDetailCreatePage,
      },
      {
        path: "/user-kyc-details/:userDetailId",
        name: "UsersKYCDetailIdPage",
        component: UsersKYCDetailIdPage,
      },
      {
        path: "/users/:userId/user-kyc-details",
        name: "UsersKYCDetailsPage",
        component: UsersKYCDetailsPage,
      },
      {
        path: "/profile/:userId",
        name: "ProfilePage",
        component: ProfilePage,
      },
      {
        path: "/users/:userId",
        name: "UserIdPage",
        component: UserIdPage,
      },
      // Positions
      {
        path: "/positions",
        name: "PositionsPage",
        component: PositionsPage,
      },
      {
        path: "/positions/create",
        name: "PositionCreatePage",
        component: PositionCreatePage,
      },
      {
        path: "/positions/:positionId",
        name: "PositionIdPage",
        component: PositionIdPage,
      },
      // Roles
      {
        path: "/roles",
        name: "RolesPage",
        component: RolesPage,
      },
      {
        path: "/roles/:roleId",
        name: "RoleIdPage",
        component: RoleIdPage,
      },
      // Modules
      {
        path: "/modules",
        name: "ModulesPage",
        component: ModulesPage,
      },
      {
        path: "/modules/create",
        name: "ModuleCreatePage",
        component: ModuleCreatePage,
      },
      {
        path: "/modules/:moduleId",
        name: "ModuleIdPage",
        component: ModuleIdPage,
      },
      // Permissions
      {
        path: "/permissions",
        name: "PermissionsPage",
        component: PermissionsPage,
      },
      {
        path: "/permissions/create",
        name: "PermissionCreatePage",
        component: PermissionCreatePage,
      },
      {
        path: "/permissions/:permissionId",
        name: "PermissionIdPage",
        component: PermissionIdPage,
      },
      // Values
      {
        path: "/values",
        name: "Values",
        component: Values,
      },
      {
        path: "/values/create",
        name: "ValueCreate",
        component: ValueCreate,
      },
      {
        path: "/values/:valueId",
        name: "ValueId",
        component: ValueId,
      },
      // ValueLists
      {
        path: "/value-lists",
        name: "ValueLists",
        component: ValueLists,
      },
      {
        path: "/value-lists/upload",
        name: "ValueListUpload",
        component: ValueListUpload,
      },
      {
        path: "/value-lists/create",
        name: "ValueListCreate",
        component: ValueListCreate,
      },
      {
        path: "/value-lists/:valueListId",
        name: "ValueListId",
        component: ValueListId,
      },
      // Outlets
      {
        path: "/outlets",
        name: "OutletsPage",
        component: OutletsPage,
      },
      {
        path: "/outlets/upload",
        name: "OutletsUploadPage",
        component: OutletsUploadPage,
      },
      {
        path: "/outlets/create",
        name: "OutletCreatePage",
        component: OutletCreatePage,
      },
      {
        path: "/outlets/:outletId",
        name: "OutletIdPage",
        component: OutletIdPage,
      },
      // OutletUsers
      {
        path: "/outlets/:outletId/outlet-users",
        name: "OutletUsersPage",
        component: OutletUsersPage,
      },
      {
        path: "/outlets/:outletId/outlet-users/create",
        name: "OutletUserCreatePage",
        component: OutletUserCreatePage,
      },
      {
        path: "/outlet-users/:outletUserId",
        name: "OutletUserIdPage",
        component: OutletUserIdPage,
      },
      // Pjps
      {
        path: "/pjps",
        name: "PjpsPage",
        component: PjpsPage,
      },
      {
        path: "/pjps/upload",
        name: "PjpsUploadPage",
        component: PjpsUploadPage,
      },
      {
        path: "/pjps/copy-pjp-references",
        name: "PjpCopyReferencesPage",
        component: PjpCopyReferencesPage,
      },
      {
        path: "/pjps/copy-pjp-prev-month",
        name: "PjpCopyPreviousMonth",
        component: PjpCopyPreviousMonth,
      },
      {
        path: "/pjps/create",
        name: "PjpCreatePage",
        component: PjpCreatePage,
      },
      {
        path: "/pjps/:pjpId",
        name: "PjpIdPage",
        component: PjpIdPage,
      },
      // PjpReferences
      {
        path: "/pjp-references",
        name: "PjpReferencesPage",
        component: PjpReferencesPage,
      },
      {
        path: "/pjp-references/create",
        name: "PjpReferenceCreatePage",
        component: PjpReferenceCreatePage,
      },
      {
        path: "/pjp-references/:pjpReferenceId",
        name: "PjpReferenceIdPage",
        component: PjpReferenceIdPage,
      },
      // UserTimestamps
      {
        path: "/user-timestamps",
        name: "UserTimestamps",
        component: UserTimestamps,
      },
      // Banners
      {
        path: "/banners",
        name: "BannersPage",
        component: BannersPage,
      },
      {
        path: "/banners/create",
        name: "BannerCreatePage",
        component: BannerCreatePage,
      },
      {
        path: "/banners/:bannerId",
        name: "BannerIdPage",
        component: BannerIdPage,
      },
      // Products
      {
        path: "/products",
        name: "ProductsPage",
        component: ProductsPage,
      },
      {
        path: "/products/create",
        name: "ProductCreatePage",
        component: ProductCreatePage,
      },
      {
        path: "/products/:productId",
        name: "ProductIdPage",
        component: ProductIdPage,
      },
      {
        path: "/products/:productId/productDetails",
        name: "ProductIDetailsPage",
        component: ProductIDetailsPage,
      },
      // Categorys
      {
        path: "/categories",
        name: "CategoriesPage",
        component: CategoriesPage,
      },
      {
        path: "/categories/create",
        name: "CategoryCreatePage",
        component: CategoryCreatePage,
      },
      {
        path: "/categories/:categoryId",
        name: "CategoryIdPage",
        component: CategoryIdPage,
      },
      //sub-categories
      {
        path: "/categories/:categoryId/sub-categories",
        name: "SubcategoryPage",
        component: SubcategoryPage,
      },
      {
        path: "/categories/:categoryId/sub-categories/create",
        name: "SubCategoryCreatePage",
        component: SubcategoryCreatePage,
      },
      {
        path: "/categories/:categoryId/sub-categories/:subcategoryId",
        name: "SubcategoryIdPage",
        component: SubcategoryIdPage,
      },
      //wishlists
      {
        path: "/wishlists",
        name: "WishlistsPage",
        component: WishlistsPage,
      },
      //BankDetails
      {
        path: "/bank-details",
        name: "BankDetailsPage",
        component: BankDetailsPage,
      },
      //carts
      {
        path: "/carts",
        name: "prodCartsPageuctsPage",
        component: CartsPage,
      },
      {
        path: "/carts/create",
        name: "CartCreatePage",
        component: CartCreatePage,
      },
      //coupons
      {
        path: "/coupons",
        name: "CouponsPage",
        component: CouponsPage,
      },
      {
        path: "/coupons/create",
        name: "CouponCreatePage",
        component: CouponCreatePage,
      },
      {
        path: "/coupons/:couponId",
        name: "CouponIdPage",
        component: CouponIdPage,
      },
      //User Address
      {
        path: "/addresses",
        name: "UserAddressesPage",
        component: UserAddressesPage,
      },
      // //notification
      {
        path: "/notifications",
        name: "NotificationsPage",
        component: NotificationsPage,
      },
      {
        path: "/notifications/create",
        name: "NotificationCreatePage",
        component: NotificationCreatePage,
      },
      {
        path: "/notifications/:notificationId",
        name: "NotificationIdPage",
        component: NotificationIdPage,
      },
      // //store
      {
        path: "/stores",
        name: "StoresPage",
        component: StoresPage,
      },
      {
        path: "/stores/create",
        name: "StoreCreatePage",
        component: StoreCreatePage,
      },
      {
        path: "/stores/:storeId",
        name: "StoreIdPage",
        component: StoreIdPage,
      },
      // Tickets
      {
        path: "/chats",
        name: "ChatsPage",
        component: ChatsPage,
      },
      {
        path: "/tickets",
        name: "TicketsPage",
        component: TicketsPage,
      },
      {
        path: "/tickets/:ticketId",
        name: "TicketIdPage",
        component: TicketIdPage,
      },
      // Withdrawals
      {
        path: "/withdrawals",
        name: "WithdrawalsPage",
        component: WithdrawalsPage,
      },
      // //orders
      {
        path: "/orders",
        name: "OrdersPage",
        component: OrdersPage,
      },
      {
        path: "/orders/create",
        name: "OrderCreatePage",
        component: OrderCreatePage,
      },
      {
        path: "/orders/:orderId",
        name: "OrderIdPage",
        component: OrderIdPage,
      },
      // OrderDetails
      {
        path: "/orders/:orderId/order-details",
        name: "OrderDetailsPage",
        component: OrderDetailsPage,
      },
      // //offers
      {
        path: "/user-subscriptions",
        name: "UserSubscriptionsPage",
        component: UserSubscriptionsPage,
      },
      // //offers
      {
        path: "/offers",
        name: "OffersPage",
        component: OffersPage,
      },
      {
        path: "/offers/create",
        name: "OfferCreatePage",
        component: OfferCreatePage,
      },
      {
        path: "/offers/:offerId",
        name: "OfferIdPage",
        component: OfferIdPage,
      },
    ],
  },
  // End AuthLayout

  // UnAuthLayout
  {
    path: "/unauth",
    name: "UnAuthLayout",
    component: UnAuthLayout,
    children: [
      {
        path: "/login",
        name: "LoginPage",
        component: LoginPage,
      },
      {
        path: "/forgot-password",
        name: "ForgotPasswordPage",
        component: ForgotPasswordPage,
      },
      {
        path: "/account-delete-request/create",
        name: "DeleteAccountRequestPage",
        component: DeleteAccountRequestPage,
      },
      {
        path: "/account-delete-request",
        name: "DeleteAccountRequestIndexPage",
        component: DeleteAccountRequestIndexPage,
      },
      {
        path: "/terms-and-conditions",
        name: "TermsAndConditionsPage",
        component: TermsAndConditionsPage,
      },
      {
        path: "/privacy-policy",
        name: "PrivacyPolicyPage",
        component: PrivacyPolicyPage,
      },
    ],
  },
  //End UnAuthLayout
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (store.getters["auth/authenticated"] && from.name) {
    to.params.startTime = new Date();
  }
  const extraPublicRoutes = [
    "TermsAndConditionsPage",
    "PrivacyPolicyPage",
    "DeleteAccountRequestPage",
  ];
  if (extraPublicRoutes.includes(to.name)) {
    return next();
  }
  if (
    to.name === "LoginPage" ||
    to.name === "RegisterPage" ||
    to.name === "ForgotPasswordPage"
  ) {
    console.log("1");
    if (store.getters["auth/authenticated"]) {
      console.log("2");
      let company_id = store.getters["auth/company"].id;
      if (company_id) {
        console.log("3");
        console.log(company_id);
      }
      return next({
        name: "HomePage",
      });
    }
    next();
  } else if (!store.getters["auth/authenticated"]) {
    console.log("4");
    return next({
      name: "LoginPage",
    });
  } else if (to.name === null) {
    console.log("5");
    return next({
      name: "HomePage",
    });
  }
  next();
});

router.afterEach(async (to, from) => {
  if (
    store.getters["auth/authenticated"] &&
    from.name &&
    !to.name.includes("Create") &&
    !to.name.includes("Edit")
  ) {
    let endTime = new Date();
    let startTime = from.params.startTime;
    let timeSpentInSeconds = "0";
    if (startTime) {
      timeSpentInSeconds = (endTime - startTime) / 1000;
    }
    if (timeSpentInSeconds > 1200) {
      timeSpentInSeconds = 1200;
    }
    console.log(
      `Time spent on "${to.name}" route: ${timeSpentInSeconds} seconds`
    );
    let form = {
      from_path: from.path,
      from_name: from.name,
      user_id: store.getters["auth/user"].id,
      timespent: timeSpentInSeconds,
    };
    await axios.post(`/user_timestamps`, form);
  }
});

export default router;
